<div
    class="flex-align-center flex gap-2 rounded-lg border-2 border-solid p-4 dark:border-contrast-yellow"
    [ngClass]="{
        'border-secondary': selectedCompany?.company_name === organization.company_name,
        'opacity-60': selectedCompany?.company_name !== organization.company_name && (isContrast$ | async)
    }"
    (click)="
        !disabled &&
            organizationSelected.emit(selectedCompany?.company_name === organization.company_name ? null : organization)
    ">
    <ion-icon
        class="orb-app-light:text-secondary h-8 w-8 text-primary dark:filter-yellow"
        src="{{ assetsPath$ | async }}/img/purchase-flow-v2/cart/company-invoice.svg"></ion-icon>
    <div>
        <p class="text-base font-bold">{{ organization.company_name }}</p>
        <p class="text-base">
            {{ 'CART_PAYMENT_COMPANY_BALANCE' | translate
            }}{{ ' ' + (organization.credit.balance | moneyFormat) + ' ' + currency }}
        </p>
    </div>
</div>
